import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { minorScale, majorScale, Icon, Table } from 'evergreen-ui'

export default class Option extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    style: PropTypes.any,
    height: PropTypes.number,
    onSelect: PropTypes.func,
    isHighlighted: PropTypes.bool,
    isSelected: PropTypes.bool
  }

  render() {
    const {
      label,
      onSelect,
      onDeselect,
      isHighlighted,
      isSelected,
      style,
      height,
      ...props
    } = this.props

    return (
      <Table.Row
        isSelectable
        isHighlighted={isHighlighted}
        onSelect={onSelect}
        onDeselect={onDeselect}
        isSelected={isSelected}
        style={style}
        display="flex"
        alignItems="center"
        height={height}
        {...props}
      >
        <Table.Cell
          paddingLeft={minorScale(3)}
          paddingRight={majorScale(1)}
          flex="none"
          opacity={isSelected ? 1 : 0}
        >
          <Icon
            icon="tick"
            color={isSelected ? 'selected' : 'default'}
            size={12}
          />
        </Table.Cell>
        <Table.TextCell
          textProps={isSelected ? { color: 'selected' } : {}}
          paddingLeft={0}
          borderRight={null}
          flex={1}
          alignSelf="stretch"
        >
          {label}
        </Table.TextCell>
      </Table.Row>
    )
  }
}
